import type { ModuleManifest } from "./types";

export const documentsManifest: ModuleManifest = {
  name: "documents",
  label: "Document",
  labelPlural: "Documents",

  coreBOSModule: "Documents",
  wsidPrefix: "7x",

  type: "standard",

  routes: {
    list: "/documents",
    show: "/documents/show/:id",
    create: "/documents/create",
    edit: "/documents/edit/:id",
  },

  navigation: {
    icon: "FolderOutlined",
    order: 8,
    group: "CRM",
  },

  routing: {
    keywords: [
      "document",
      "documents",
      "file",
      "files",
      "attachment",
      "attachments",
      "note",
      "notes",
    ],
    searchFields: ["notes_title", "filename"],
    defaultSort: { field: "modifiedtime", order: "desc" },
  },

  context: {
    supported: true,
    entityKey: "documents",
  },

  fields: [
    { name: "notes_title", label: "Title", type: "string", required: true },
    { name: "filename", label: "File Name", type: "string" },
    { name: "filetype", label: "File Type", type: "string", readonly: true },
    { name: "filesize", label: "File Size", type: "number", readonly: true },
    {
      name: "filelocationtype",
      label: "Location Type",
      type: "picklist",
      options: [
        { value: "I", label: "Internal" },
        { value: "E", label: "External" },
      ],
    },
    {
      name: "filedownloadcount",
      label: "Download Count",
      type: "number",
      readonly: true,
    },
    {
      name: "filestatus",
      label: "Active",
      type: "boolean",
      defaultValue: true,
    },
    { name: "fileversion", label: "Version", type: "string" },
    {
      name: "folderid",
      label: "Folder",
      type: "reference",
      referenceModule: "DocumentFolders",
    },
    { name: "notecontent", label: "Note Content", type: "text" },
    {
      name: "assigned_user_id",
      label: "Assigned To",
      type: "reference",
      referenceModule: "Users",
      hidden: true,
      defaultValue: "19x1",
    },
  ],

  relationships: [
    {
      module: "Accounts",
      relation: "many-to-many",
      label: "Accounts",
      icon: "BankOutlined",
      displayField: "accountname",
    },
    {
      module: "Contacts",
      relation: "many-to-many",
      label: "Contacts",
      icon: "UserOutlined",
      displayField: "lastname",
    },
  ],

  requiredFields: ["notes_title", "assigned_user_id"],

  // Mass edit - fields are dynamically loaded from filterFields
  massEdit: {
    enabled: true,
  },
  viewStrategy: "bespoke",
};
